export const APP_NAME = 'sparqle';
export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME || '_sparqle_session';

export const TIME_FORMAT = 'HH:mm';
export const DAYTIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const DAY_FORMAT = 'DD/MM/YYYY';
export const DATE_BACKEND_FORMAT = 'YYYY-MM-DD';

export const PAGE_SIZE = 15;
export const PAGE_SIZE_OPTIONS = [PAGE_SIZE, 50, 100];

export const LOCATION_TYPE = {
  STORE: 'STORE',
  OFFICE: 'OFFICE',
  HUB: 'HUB',
  RESTAURANT: 'RESTAURANT',
};

export const RIDER_TYPE = {
  FIXED: 'FIXED',
  FREELANCE: 'FREELANCE',
  PARTNER: 'PARTNER',
};

export const TYPE_PAGE = {
  NEW: 'new',
  EDIT: 'edit',
  DRAFT: 'draft',
};

export const DAY_NAME = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
};

export const VEHICLE_TYPE = [
  'DOCKR - Urban Arrow L',
  'FULPRA - 2000 L',
  'Bullitt Cargo',
  'Omnium MiniMax',
  'Regular Bike with Bag',
  'Volkswagen ID Buzz',
  'Opel Vivaro',
];

export const VEHICLE_CAPACITY = {
  'DOCKR - Urban Arrow L': 300,
  'FULPRA - 2000 L': 2000,
  'Bullitt Cargo': 400,
  'Omnium MiniMax': 290,
  'Regular Bike with Bag': 110,
  'Volkswagen ID Buzz': 3900,
  'Opel Vivaro': 5000,
};

export const VEHICLE_CATEGORY = {
  'DOCKR - Urban Arrow L': 'BIKE',
  'FULPRA - 2000 L': 'BIKE',
  'Bullitt Cargo': 'BIKE',
  'Omnium MiniMax': 'BIKE',
  'Regular Bike with Bag': 'BIKE',
  'Volkswagen ID Buzz': 'CAR',
  'Opel Vivaro': 'CAR',
};

export const ROLES = {
  ADMIN: 'ADMIN',
  DISPATCHER: 'DISPATCHER',
  COMPANY_OWNER: 'COMPANY_OWNER',
  LOCATION_USER: 'LOCATION_USER',
  CARRIER_USER: 'CARRIER_USER',
  SORTER: 'SORTER',
};

export const ORDER_TYPE = {
  SAME_DAY: 'SAME DAY',
  NEXT_DAY: 'NEXT DAY',
  SCHEDULED: 'SCHEDULED',
};

export const ORDER_STATUSES = {
  ERROR: 'ERROR',
  DRAFT: 'DRAFT',
  EXPECTED: 'EXPECTED',
  IN_TRANSIT: 'IN TRANSIT',
  AWAITING_NEXT_ATTEMPT: 'AWAITING NEXT ATTEMPT',
  OUT_FOR_DELIVERY: 'OUT FOR DELIVERY',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  ADDRESS_NOT_FOUND: 'ADDRESS NOT FOUND',
  // collo statuses
  FAILED: 'FAILED',
  RETURNED: 'RETURNED',
  AT_PICKUP_POINT: 'AT PICKUP POINT',
  INACTIVE: 'INACTIVE',
  MISSING: 'MISSING',
};

export const ORDER_PACKAGE_WAS = {
  EMPTY: null,
  SAFE_DROPPED: 'Safe Dropped',
  DELIVERED_AT_NEIGHBOUR: 'Delivered at Neighbour',
  RECEIVED_BY_CUSTOMER: 'Received by Customer',
};

export const FAILED_REASONS = {
  EMPTY: null,
  CUSTOMER_UNRESPONSIVE: 'Customer unresponsive',
  UNSAFE_DELIVER_CONDITIONS: 'Unsafe delivery conditions',
  PACKAGE_NOT_READY: 'Package not ready',
  OTHER: 'Other',
};

export const ROUTE_PLAN_STATUSES = {
  DRAFT: 'DRAFT',
  OPTIMIZED: 'OPTIMIZED',
  DISPATCHED: 'DISPATCHED',
};

export const COLOR_DEFAULT = '92BEFF';
export const SPARQLE_DARK_BLUE = '4f8ce0';
export const SPARQLE_PURPLE = 'F5E3FF';

export const ONE_HOUR_PX_DEFAULT = 150;

export const COLORS = [
  'ed8f8f',
  'f284a8',
  'c788d2',
  'aa92d6',
  '959ed5',
  '85c3f8',
  '76cef9',
  '75c4bc',

  'cd2929',
  'd21a55',
  '8321a0',
  '532fa8',
  '1c7de1',
  '0790e1',
  '00a2b9',
  '007e70',

  'ae1a1a',
  '7d1046',
  '411481',
  '2b1a87',
  '0f3e97',
  '044d90',
  '005559',
  '004438',

  '9bd09d',
  'bddd9b',
  'e2eb91',
  'fff392',
  'ffc575',
  'ffa186',
  'd1c5c1',
  'c8d2d7',

  '3b963e',
  '71aa3a',
  'b8c32d',
  'fdd22f',
  'fa8100',
  'f2471c',
  '826358',
  '859aa4',

  '1a531d',
  '2d5e1c',
  '776c17',
  'f37417',
  'e24700',
  'b72f0f',
  '533830',
  '3c5059',
];

export const OLD_COLORS = [
  '00C8B4',
  '00E509',
  '9E69E0',
  '9FDC70',
  '23A9F6',
  '83C3FF',
  '641EFD',
  '669A3D',
  '748BFF',
  'C64EFF',
  'DC70C4',
  'F58585',
  'FF3535',
  'FF9365',
  'FFAB00',
  '606060',
  '7732EF',
];

export const STEP_TYPE = {
  pickup: 'PICKUP',
  delivery: 'DELIVERY',
};

export const userActivityEventTypes = {
  button_click: 'button_click',
  page_view: 'page_view',
  login: 'login',
  logout: 'logout',
  form_submit: 'form_submit',
  hover: 'hover',
};
